import { all, fork } from 'redux-saga/effects';
import create from './create';
import list from './list';
import unread from './unread';
import leave from './leave';

export default function* channel() {
  yield all([fork(create), fork(list), fork(unread), fork(leave)]);
}
